import { render, staticRenderFns } from "./projectInfo.vue?vue&type=template&id=7a6e31c8&scoped=true&"
import script from "./projectInfo.vue?vue&type=script&lang=js&"
export * from "./projectInfo.vue?vue&type=script&lang=js&"
import style0 from "./projectInfo.vue?vue&type=style&index=0&id=7a6e31c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6e31c8",
  null
  
)

export default component.exports